import TimeBetween from '@/components/ezuro/common/TimeBetween.vue'
import CreateSchedule from '@/components/ezuro/workschedule/components/CreateSchedule.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';
import moment from 'moment';

const defaultEl = {
  id: null,
  user_id: null,
  department_id: null,
  division_id: null,
  shift_id: null,
  work_from_home: false,
  datetime_start: '',
  datetime_end: '',
  notes: '',
  schedule_id: null,
  only_comment: false
};

export default {
  name: 'Info',
  props: {
    elData: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    isModal: {
      type: Boolean
    },
    allowMultiDepartmentSelect: {
      type: Boolean
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    }
  },
  components: {
    TimeBetween,
    CreateSchedule
  },
  data () {
    return {
      userOptions: [],
      shiftOptions: [],
      shifts: {},
      editEl: defaultEl,
      scheduleConfirmed: false
    }
  },
  validations: {
    editEl: {
      user_id: {},
      department_id: { required },
      division_id: {},
      shift_id: {},
      work_from_home: {},
      only_comment: {},
      datetime_start: { required },
      datetime_end: { required },
      notes: {}
    }
  },
  computed: {
    ...mapState(['config']),
    departmentOptions () {
      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => {
          return (
            this.filterData.company_id.includes(parseInt(el.company_id)) &&
            (!this.filterData.department_id.length || this.filterData.department_id.includes(parseInt(el.value)))
          );
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      const divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['department_id']
      ).filter(
        el => {
          return (
            this.editEl.department_id == el.department_id &&
            (!this.filterData.division_id.length || this.filterData.division_id.includes(parseInt(el.value)))
          );
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(divisions, 'sortText');
    },
    canEdit () {
      return !this.isLoading && this.editEl.schedule_id && !this.scheduleConfirmed;
    }
  },
  methods: {
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    getEmployeeName (id) {
      for (const key in this.scheduleData.users[this.editEl.department_id]) {
        if (this.scheduleData.users[this.editEl.department_id][key].id == id) {
          return this.scheduleData.users[this.editEl.department_id][key].fullname;
        }
      }
    },
    getUserOptions () {
      this.userOptions = [];
      const scheduleKey = this.editEl.department_id + (this.editEl.division_id ? '_' + this.editEl.division_id : '');

      for (const key in this.scheduleData.users[scheduleKey]) {
        if (this.scheduleData.users[scheduleKey][key].id && this.scheduleData.users[scheduleKey][key].fullname) {
          this.userOptions.push({ value: this.scheduleData.users[scheduleKey][key].id, text: this.scheduleData.users[scheduleKey][key].fullname });
        }
      }

      return this.userOptions;
    },
    getShiftOptions () {
      this.shiftOptions = [];

      if (this.editEl.department_id) {
        const path = 'ezuro/shifts/list?perPage=10000&department_id=' + this.editEl.department_id;

        this.$emit('setLoading', true);
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.data) {
            for (const shift of response.data) {
              this.shiftOptions.push({ value: shift.id, text: shift.name + (shift.team ? ' (' + shift.team.name + ')' : '') });
              this.shifts[shift.id] = {
                value: shift.id,
                text: shift.name,
                type: shift.type,
                time_start: shift.time_start,
                time_end: shift.time_end
              };
            }
            this.$emit('setLoading', false);
          }
        });
      }
    },
    departmentSelect (departmentId) {
      this.editEl.user_id = null;
      this.editEl.division_id = null;
      this.editEl.department_id = departmentId;
      this.getScheduleId();
      this.getUserOptions();
    },
    divisionSelect (divisionId) {
      this.editEl.user_id = null;
      this.editEl.division_id = divisionId;
      this.getScheduleId();
      this.getUserOptions();
    },
    getScheduleId () {
      if (this.editEl.id !== null) {
        for (const key in this.scheduleData.schedules) {
          if (
            this.scheduleData.schedules[key].id == this.editEl.schedule_id
          ) {
            this.scheduleConfirmed = this.scheduleData.schedules[key].status === 'confirmed';
            return;
          }
        }
      }

      this.editEl.schedule_id = null;
      this.scheduleConfirmed = false;

      for (const key in this.scheduleData.schedules) {
        if (
          this.scheduleData.schedules[key].department_id == this.editEl.department_id &&
          this.scheduleData.schedules[key].division_id == this.editEl.division_id &&
          this.scheduleData.schedules[key].type === this.editEl.type
        ) {
          this.editEl.schedule_id = this.scheduleData.schedules[key].id;
          this.scheduleConfirmed = this.scheduleData.schedules[key].status === 'confirmed';
          return;
        }
      }
    },
    shiftSelect (shiftId) {
      if (!shiftId) {
        return;
      }

      const shift = this.shifts[shiftId];

      if (shift.type === 'pattern') {
        return;
      }

      const dateStart = moment(this.editEl.datetime_start);
      const dateEnd = moment(this.editEl.datetime_end);

      this.editEl.datetime_start = moment(dateStart.format('YYYY-MM-DD') + ' ' + shift.time_start).format('YYYY-MM-DD HH:mm');
      this.editEl.datetime_end = moment(dateEnd.format('YYYY-MM-DD') + ' ' + shift.time_end).format('YYYY-MM-DD HH:mm');
    },
    remove (approved) {
      if (approved) {
        this.$emit('remove');
      } else {
        this.$refs.itemDeleteMsgBox.show(this.editEl, this.$t('general.item.deleteTitle'))
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        const reqData = { };

        for (const key of Object.keys(defaultEl)) {
          if (['datetime_start', 'datetime_end'].includes(key)) {
            reqData[key] = moment(this.editEl[key]).format('YYYY-MM-DD HH:mm');
          } else {
            reqData[key] = this.editEl[key];
          }
        }

        if (this.editEl.original_schedule_id) {
          reqData.schedule_id = this.editEl.original_schedule_id;
        }

        this.$emit('save', reqData);
      }
    },
    close () {
      this.$emit('close');
    },
    createdSchedule (data) {
      this.editEl.schedule_id = data.id;
      this.$emit('createdSchedule');
    }
  },
  mounted () {
    if (this.elData) {
      this.editEl = this.BasicHelper.cloneObject(this.elData);
    } else {
      this.editEl = this.BasicHelper.cloneObject(defaultEl);
    }

    if (this.editEl.type_id && this.editEl.type_id === 2) {
      this.editEl.only_comment = true;
    }

    this.getShiftOptions();
    this.getUserOptions();
    this.getScheduleId();

    this.v$.$reset();
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
